module.exports = __webpack_public_path__ + "static/media/retrologo.dc1be406.jpg";